import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Este libro reemplaza a mi doctor?',
  a: 'No. Este protocolo es estrictamente informativo y complementario. Está diseñado para darte herramientas prácticas para el día a día. Nunca debes ignorar el consejo de tu médico ni dejar tus medicamentos sin consultarlo.'
}, {
  q: '¿En qué formato viene el libro?',
  a: 'Es un libro digital (eBook) en formato PDF. Podrás descargarlo inmediatamente después de tu compra y leerlo en tu celular, tablet o computadora. También puedes imprimirlo.'
}, {
  q: '¿Funciona si ya tomo medicamentos para la neuropatía?',
  a: 'Sí. El protocolo de contraste térmico y las rutinas de inspección son complementarios a cualquier tratamiento médico. De hecho, te enseñamos cómo ciertos medicamentos comunes pueden requerir suplementación adicional.'
}, {
  q: '¿Cuánto tiempo tarda en hacer efecto?',
  a: 'El Protocolo SOS de 12 minutos puede proporcionar alivio temporal del ardor la misma noche. La reparación nerviosa con suplementación toma semanas o meses, pero el alivio del dolor nocturno puede ser inmediato.'
}, {
  q: '¿Tiene garantía?',
  a: 'Absolutamente. Tienes 30 días completos para leer el libro, aplicar el protocolo y ver los resultados. Si no estás satisfecho, te devolvemos el 100% de tu dinero.'
}];
export function SalesFAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-20 lg:py-28 bg-white" data-id="element-150">
      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-152">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-charcoal mb-4" data-id="element-153">
            Preguntas Frecuentes
          </h2>
          <div className="w-20 h-1 bg-gold-brand mx-auto rounded-full" data-id="element-154" />
        </motion.div>

        <div className="space-y-3" data-id="element-155">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-156">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex justify-between items-center p-5 sm:p-6 bg-cream hover:bg-emerald-light/50 transition-colors text-left" aria-expanded={open === i} data-id="element-157">
                <span className="text-lg sm:text-xl font-heading font-bold text-charcoal pr-4" data-id="element-158">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-emerald-brand flex-shrink-0 transition-transform duration-300 ${open === i ? 'rotate-180' : ''}`} data-id="element-159" />
              </button>
              <AnimatePresence data-id="element-160">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-161">
                    <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-base sm:text-lg font-body text-gray-700 leading-relaxed border-t border-gray-100 pt-4" data-id="element-162">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}